//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//控制《报销单详情页面》费用详情显示隐藏
var infoShowHide = '';
import { saveReExpeAcco, selectExpeAcco, selectCostDetail, costTypeSelect, selectFillList, FILE_URL } from '@/api/rem/cost/cost';
import { DORM } from "@/config/constant";
import { guid, formatTime } from '@/common/common'

import promise from '@/axios/promise';
export default {
	filters: { 
		numFilter(value) {  // 截取当前数据到小数点后两位
			  
			let realVal = parseFloat(value).toFixed(2);   // num.toFixed(2)获取的是字符串
			  
			return realVal 
		},
		dateFilter(value) {
			return value.substring(0, value.length - 2)

		}
	},
	data() {
		return {
			apprNumb: this.$route.query.businessKey,
			data: {
				costType: '',
				creaTime: '',
				invoNumb: '',
				date: undefined,
				reimRemark: '',
				fid: '',
				taskType: '',
				reimCostNumb: 0
			},
			dataList: '',
			reimCostList: [],
			costDetail: '',
			costInfoList: [],
			costInfofield: [],
			costfillList: [],
			solo: true,
			file_URL: '',
		}
	},
	created() {
		console.log(this.$route.query)
		this.taskType = this.$route.query.taskType
		console.log(this.$route.query.businessKey)
		var fid = {
			'fid': this.$route.query.businessKey
		}
		selectExpeAcco(fid).then(response => {
			console.log(response);
			this.data = response;
		})
		promise({
			url: DORM + "/expense/selectDictionType",
			method: "get",
			async: false,
			params: {
				type: "fileUrl"
			}
		}).then(res => {
			console.log(res);
			this.file_URL = res[0].dicCode
		});

	},
	methods: {
		// 日期格式化
		dateFormatter(date, format) {
			return formatTime(date, format);
		},
		bacList() {
			this.$router.push({
				path: '/app/remb/reimList'
			})
		},
		//查看费用详情
		seeCostDetail(costType, event, infoFid) {
			console.log(infoFid)
			console.log('详情')
			event.stopImmediatePropagation();
			// console.log(event.currentTarget)
			// console.log(event.target)
			// console.log($(event.currentTarget).find(".extendInfo"))
			var extendInfoTarget = event.currentTarget;
			console.log(infoFid)
			if(infoShowHide == infoFid) {

				infoShowHide = ''
				this.costInfoList = [];
				this.costInfofield = [];
				this.costfillList = [];
				$(event.currentTarget).css('background', 'white')

			} else {
				$('.LookCostDetail').css('background', 'white')
				$(event.currentTarget).css('background', '#F3F4F5')
				$('.extendInfoParents').css('height', '0px');
				$(event.currentTarget).next('.extendInfoParents').css('height', 'auto')

				var thiss = this
				setTimeout(function() {
					infoShowHide = infoFid;
					var fid = {
						'Fid': infoFid
					}
					selectCostDetail(fid).then(response => {
						thiss.costDetail = response
						console.log(thiss.costDetail)
						thiss.costSelectLoad1(costType, extendInfoTarget)
					})
					var fillMainId = {
						'mainId': infoFid
					}
					selectFillList(fillMainId).then(res => {
						thiss.costfillList = res;
						console.log(thiss.costfillList)
					})
				}, 500)
			}

		},
		//点击查看费用
		costSelectLoad1(costType, extendInfoTarget) {
			var info = {
				'Fid': costType
			};
			console.log(costType);
			costTypeSelect(info).then(response => {
				//sample 文本框
				//single 单选框
				//Number 数字名称
				//provincesCities 省市框
				//Multiline 多行文本框
				//multiSelect 多选文本
				//times 日期框
				//dormitory 宿舍框
				this.costInfofield = [];
				this.costInfoList = response.costTypeMinor;
				for(var i = 0; i < response.costTypeMinor.length; i++) {
					if(response.costTypeMinor[i].fielType == "single" || response.costTypeMinor[i].fielType == "multiSelect") {
						if(response.costTypeMinor[i].fielType == "multiSelect") {
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.costDetail[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							if(prinConcData != null) {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': prinConcData.split(','),
									'extend': extend.split(';')
								};
								this.costInfofield.push(field)
							} else {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': '',
									'extend': extend.split(';')
								};
								this.costInfofield.push(field)
							}

						} else {
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.costDetail[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							var field = {
								field: response.costTypeMinor[i].prinConc,
								'value': prinConcData,
								'extend': extend.split(';')
							};
							this.costInfofield.push(field)
						}

					} else if(response.costTypeMinor[i].fielType == "dataDiction") {
						var extend1 = response.costTypeMinor[i].extend;
						var info = {
							'type': extend1
						}
						var index = i;
						var _this = this;
						var arr = [];
						promise({
							url: DORM + "/expense/selectDictionType",
							method: "get",
							async: false,
							params: {
								type: extend1
							}
						}).then(res => {
							console.log(res);
							if(res.length != 0) {
								for(var K = 0; K < res.length; K++) {
									var file = res[K].dicName;
									arr.push(file)
								}

							}
						});
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.costDetail[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[index].prinConc,
							'value': prinConcData,
							'extend': arr
						};
						_this.costInfofield.push(field)
					} else {
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.costDetail[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[i].prinConc,
							'value': prinConcData,
							'extend': []
						};
						this.costInfofield.push(field)
					}

				}
				console.log(this.costInfofield)
				console.log(this.costInfoList)
			});
		},
		//驳回报销单
		backReim() {
			var data = {};
			data.costType = this.data.costType;
			data.creaTime = this.data.creaTime;
			data.invoNumb = this.data.invoNumb;
			data.reimRemark = this.data.textarea;
			data.costInFo = this.reimCostList;
			data.fid = this.data.fid;
			data.submitType = 'save'
			var reimData = {
				reimburse: JSON.stringify(data)
			}
			console.log(reimData);
			// saveReExpeAcco(reimData).then(respones=>{
			//   console.log(respones)
			// })

		},
		//报销单通过
		submitReim() {
			var data = {};
			data.costType = this.data.costType;
			data.creaTime = this.data.creaTime;
			data.invoNumb = this.data.invoNumb;
			data.reimRemark = this.data.textarea;
			data.costInFo = this.reimCostList;
			data.fid = this.data.fid;
			data.submitType = 'submit'
			var reimData = {
				reimburse: JSON.stringify(data)
			}
			console.log(reimData);
			// saveReExpeAcco(reimData).then(respones=>{
			//   console.log(respones)
			// })
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/reimSee.vue